import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Header.css";

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className="app__header-h1">The Key To Fine Food</h1>
      <p className="p__opensans" style={{ margin: "2rem 0" }}>
        As us Indians are increasingly becoming curious about the different
        cutures and cuisines, what better way is there to learn about a culture
        than through their food? And so, SHAH-I-LICIOUS has decided to bring a
        variety of cuisines to you with a homely touch. Our venture includes
        cuisines like Mexican, Lebanese, Italian and so on, which would be
        gradually introduced to you. It would be our pleasure to serve you.
      </p>
      <button type="button" className="custom__button">
        Explore Menu
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </div>
  </div>
);

export default Header;
